import { render, staticRenderFns } from "./AuthenticationPopupManager.vue?vue&type=template&id=210de25e&scoped=true"
import script from "./AuthenticationPopupManager.vue?vue&type=script&lang=ts"
export * from "./AuthenticationPopupManager.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationPopupManager.vue?vue&type=style&index=0&id=210de25e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210de25e",
  null
  
)

export default component.exports